import './DeckNavBar.css';

interface DeckNavBarProps {
  logoUrl?: string;
  logoText: string;
  currentSlide: number;
  totalSlides: number;
  variant?: 'default' | 'minimal';
}

export default function DeckNavBar({
  logoUrl,
  logoText,
  currentSlide,
  totalSlides,
  variant = 'default',
}: DeckNavBarProps) {
  return (
    <nav className={`deck-nav-bar deck-nav-bar--${variant}`}>
      <div className="deck-nav-bar__logo">
        {logoUrl && (
          <img
            src={logoUrl}
            alt={logoText}
            className="deck-nav-bar__logo-image"
          />
        )}
        <span>{logoText}</span>
      </div>
      <div className="deck-nav-bar__counter">
        <span>{currentSlide + 1}</span> / <span>{totalSlides}</span>
      </div>
    </nav>
  );
}
